// Renders assistant markdown and sanitizes it — a real security boundary,
// not just formatting.

import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ gfm: true, breaks: true });

// Hard-allowlist the output surface rather than trusting the prompt alone.
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'del',
  'code',
  'pre',
  'blockquote',
  'ul',
  'ol',
  'li',
  'a',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'hr',
];
const ALLOWED_ATTR = ['href', 'title', 'target', 'rel', 'align'];
// No javascript:, no data: — only real links and anchors.
const ALLOWED_URI_REGEXP = /^(?:https?:|mailto:|#)/i;

let hooked = false;
function ensureHooks(): void {
  if (hooked) return;
  hooked = true;
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer ugc');
    }
  });
}

/** Render assistant markdown to sanitized HTML, safe to inject as innerHTML. */
export function renderMarkdown(md: string): string {
  ensureHooks();
  const html = marked.parse(md, { async: false }) as string;
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
    FORBID_TAGS: ['style', 'img', 'svg', 'iframe', 'form', 'input'],
  });
}

/** Sources come from the KB DB, not the model — validate before rendering as a link. */
export function isSafeSourceUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
